export class HaaiError {
  public result: string;
  public path: string;
  public code: number;
  public traceId: string;

  constructor(errorObj?: any) {
    this.result = errorObj?.result ?? 'Not implement';
    this.path = errorObj?.path ?? 'Not implement';
    this.code = errorObj?.code ?? '-1';
    this.traceId = errorObj?.traceId ?? 'Not implement';
  }
}
